import jwtDecode from 'jwt-decode';
import React, { createContext, useReducer } from 'react';
import { actionTypes } from '../globalData';


const initialState = {
  user: null,
};


if (localStorage.getItem('token')) {
  const decodedToken = jwtDecode(localStorage.getItem('token'));
  if (decodedToken.exp * 1000 < Date.now()) {
    localStorage.removeItem('token');
  } else {
    initialState.user = decodedToken;
  }
}

const AuthContext = createContext({
  user: null,
  login: (userData) => { },
  logout: () => { },
});

function authReducer(state, action) {
  switch (action.type) {
    case actionTypes.LOGIN_ACTION:
      return {
        ...state,
        user: action.payload,
      };
    case actionTypes.EDIT_PROFILE_ACTION:
      return {
        ...state,
        user: action.updated,
      };
    case actionTypes.LOGOUT_ACTION:
      return {
        ...state,
        user: null,
      };
    default:
      return state;
  }
}

const AuthProvider = (props) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const login = (data) => {
    localStorage.setItem('token', data.token);
    localStorage.setItem('aliv_token', data.aliv_token);
    dispatch({
      type: actionTypes.LOGIN_ACTION,
      payload: data.user,
    });
  }

  const editProfile = (updatedData) => {
    // localStorage.setItem('user', JSON.stringify(updatedData));
    dispatch({ type: actionTypes.EDIT_PROFILE_ACTION, updatedData });
  }

  const logout = () => {
    localStorage.removeItem('token');
    dispatch({ type: actionTypes.LOGOUT_ACTION });
  }

  return (
    <AuthContext.Provider
      value={{
        user: state.user,
        login,
        logout,
        editProfile,
      }}
      {...props}
    />
  );
}

export { AuthContext, AuthProvider };
